import { p as pickFields, e as extractClickData, a as getFormData, b as addHashedData, c as extractIds, v as videoData, f as extractCommonPayload, w as waitFor } from "../../../videoData-0717aa43.js";
import { logger } from "../../../utils/logger.es.js";
import "../../../analytics-8755db5d.js";
import "../../../analytics-plugin-original-source.browser.es-b315981a.js";
import "../../../cookies-56ad18bd.js";
const omitFields = (fields, obj) => {
  if (!fields || !obj) {
    return obj;
  }
  const result = { ...obj };
  fields.forEach((field) => delete result[field]);
  return result;
};
const generateTealiumPayload = async (application, fields, payload, type) => {
  var _a, _b, _c;
  const props = payload == null ? void 0 : payload.properties;
  const allData = props == null ? void 0 : props.application_data;
  const applicationData = fields ? pickFields(fields, allData) : allData;
  const pageName = props == null ? void 0 : props.page_name;
  const clickData = extractClickData(payload.properties, application);
  const eventAction = type === "page" ? "page_view" : props == null ? void 0 : props.event_action;
  const eventName = type === "page" ? "Page Loaded" : payload.event;
  let tealiumFormData = {};
  if ((_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.form) {
    ({ tealiumFormData } = await getFormData((_b = payload == null ? void 0 : payload.properties) == null ? void 0 : _b.form) || {});
  }
  const hashedData = await addHashedData(applicationData);
  const appData = { ...applicationData, ...hashedData };
  const extractedId = await extractIds(payload);
  const video = videoData(payload);
  return {
    referrer: ((_c = payload == null ? void 0 : payload.properties) == null ? void 0 : _c.referrer) || null,
    ...omitFields(["form_email", "form_phone"], appData),
    ...extractCommonPayload(payload, application),
    ...omitFields(["auth0_email"], extractedId),
    ...clickData,
    ...video,
    event_action: eventAction,
    event_name: `${pageName} - ${eventName}`,
    ...tealiumFormData,
    lead_stage: payload.properties.lead_stage || null,
    lead_type: payload.properties.lead_type || null,
    page_view_id: payload.properties.page_view_id,
    tealium_event: eventAction,
    time_since_last_event: payload.properties.time_since_last_event
  };
};
const utag = () => window.utag;
const analyticsTealium = ({
  userConfig,
  application,
  includedFields
}) => {
  return {
    config: Object.assign({}, userConfig),
    name: "analytics-tealium",
    page: async ({ payload }) => {
      let uTagResolver;
      const uTagPromise = new Promise((resolve) => {
        uTagResolver = resolve;
      });
      waitFor(utag, async () => {
        const payloadToSend = await generateTealiumPayload(
          application,
          includedFields,
          payload,
          "page"
        );
        const uTagCallBack = () => {
          uTagResolver();
          logger.info(
            `ANALYTICS :: tealium :: page - ${payloadToSend == null ? void 0 : payloadToSend.event_name}`,
            payloadToSend
          );
        };
        utag().view(payloadToSend, uTagCallBack);
      });
      return uTagPromise;
    },
    track: async ({ payload, instance }) => {
      var _a, _b;
      const pageDataProperties = (_b = (_a = instance.getState("page")) == null ? void 0 : _a.last) == null ? void 0 : _b.properties;
      const pageName = payload.properties.page_name || pageDataProperties.page_name || pageDataProperties.application_data.page_name;
      payload.properties.page_name = pageName;
      let uTagResolver;
      const uTagPromise = new Promise((resolve) => {
        uTagResolver = resolve;
      });
      waitFor(utag, async () => {
        const payloadToSend = await generateTealiumPayload(
          application,
          includedFields,
          payload,
          "track"
        );
        const uTagCallBack = () => {
          uTagResolver();
          logger.info(
            `ANALYTICS :: tealium :: track - ${payloadToSend == null ? void 0 : payloadToSend.event_name}`,
            payloadToSend
          );
        };
        utag().link(payloadToSend, uTagCallBack);
      });
      return uTagPromise;
    }
  };
};
export {
  analyticsTealium
};
